export function getRandomInteger(min, max) {
  // Ensure min and max are integers
  min = Math.ceil(min);
  max = Math.floor(max);

  // Generate random integer between min and max (inclusive)
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generatSerialNo() {
  return getRandomInteger(1000, 9999).toString();
}

export function generateDateTime() {
  // Get current date and time
  const now = new Date();

  // Format DD-MM-YYYY-HHMMSS for file names
  const timestamp = now
    .toISOString() // e.g. "2026-03-30T09:33:22.123Z"
    .replace(/T/, "-") // replace 'T' with dash
    .replace(/:/g, "") // remove colons
    .split(".")[0]; // remove milliseconds

  // Rearrange to DD-MM-YYYY-HHMMSS
  const [year, month, day, time] = [
    timestamp.slice(0, 4),
    timestamp.slice(5, 7),
    timestamp.slice(8, 10),
    timestamp.slice(11),
  ];

  return `${day}-${month}-${year}-${time}`;
}

export const headers = [
  "serial",
  "date",
  "party",
  "cash",
  "pc_weight",
  "pc_amount",
  "lab_weight",
  "lab_amount",
  "lab_report",
  "bar_weight",
  "bar_amount",
  "coin_weight",
  "coin_amount",
  "karat",
  "ginni_weight",
  "ginni_amount",
  "ginni_report",
  "silver_weight",
  "silver_bar",
  "silver_amount",
  "rwg_weight",
  "rwg_rate",
  "rwg_amount",
  "rws_weight",
  "rws_rate",
  "rws_amount",
];

export const normalizeRows = (rows) => {
  return rows.map((row) => {
    const normalized = {};
    headers.forEach((key) => {
      normalized[key] = row[key] ?? "";
    });
    return normalized;
  });
};
